import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Tooltip, Typography } from '@mui/material'

export const DataGridRowBulletPoint = forwardRef(({ color, text }, ref) => {
  return (
    <Typography className={'DataGridRowBulletPoint'}>
      {text ? (
        <Tooltip ref={ref} title={text}>
          <>
            <span className="DataGridRowBulletPoint-point" style={{ background: color }} />
            <span className="DataGridRowBulletPoint-text">{text}</span>
          </>
        </Tooltip>
      ) : (
        <>
          <span className="DataGridRowBulletPoint-point" style={{ background: color }} />
          <span className="DataGridRowBulletPoint-text">{text}</span>
        </>
      )}
    </Typography>
  )
})

DataGridRowBulletPoint.displayName = 'DataGridRowBulletPoint'

DataGridRowBulletPoint.propTypes = {
  color: PropTypes.string.isRequired,
  text: PropTypes.string
}

DataGridRowBulletPoint.defaultProps = {
  color: '#000000',
  text: null
}
